// Ay filtresindeki "Güncel Ay" seçeneği için ortak çözümleme mantığı.
// İçinde bulunulan yıldan önceki yıllarda 12. ay, içinde bulunulan yılda ise
// veri girilmiş en son ay baz alınır.
export const GUNCEL_AY = 'guncel';

export async function cozGuncelAy(
  yil: number,
  isletmeId: string | number | undefined,
  listeFn: (params: any) => Promise<{ data: any[] }>
): Promise<number> {
  const simdi = new Date();
  const buYil = simdi.getFullYear();
  if (yil < buYil) return 12;

  const params: any = { yil };
  if (isletmeId) params.isletme_id = isletmeId;
  const r = await listeFn(params);
  const aylar = (r.data || [])
    .map((k: any) => Number(k.ay))
    .filter((a: number) => !isNaN(a));
  return aylar.length ? Math.max(...aylar) : simdi.getMonth() + 1;
}
